import { ContentState } from 'draft-js'
import { flatten } from 'ramda'

import { IDraftRelatedContent } from '~/redux/types'
import { IANSReference } from '~/types'
import converterFactory from './converterFactory'
import headlineFactory from './headlineFactory'

interface IDraftContent {
  contentState?: ContentState
}

export function draftContentStateToAns(
  {
    contentElements = {},
    headlines = {},
    subheadlines = {},
  }: {
    contentElements: IDraftContent
    headlines: IDraftContent
    subheadlines: IDraftContent
  },
  options: {
    removeEmptyParagraphs: boolean
  }
): {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  contentElements: any
  headlines: any
  subheadlines: any
  /* eslint-enable @typescript-eslint/no-explicit-any */
} {
  const { contentState } = contentElements
  const { contentState: headlineContentState } = headlines
  const { contentState: subheadlineContentState } = subheadlines

  return {
    contentElements: contentState
      ? converterFactory.toAnsList(contentState, options).toJS()
      : null,
    headlines: headlineContentState
      ? headlineFactory.toAnsList(headlineContentState).first()
      : null,
    subheadlines: subheadlineContentState
      ? headlineFactory.toAnsList(subheadlineContentState).first()
      : null,
  }
}

export function draftRelatedContentToAns(
  relatedContentData?: Pick<IDraftRelatedContent, 'data'>
): IANSReference[] {
  if (!relatedContentData) {
    return []
  }

  const relatedContentDataArray = Object.keys(relatedContentData)
    .filter(
      (key) => !!relatedContentData[key] && relatedContentData[key].length > 0
    )
    .map((key: string) => {
      return relatedContentData[key].map((item) =>
        item.get('clipboardANS').toJS()
      )
    })

  return flatten(relatedContentDataArray)
}
